export { ReactComponent as AccountIcon } from './account.svg';
export { ReactComponent as AccountantTreasurerIcon } from './AccountantTreasurer.svg';
export { ReactComponent as AddUser } from './add-user.svg';
export { ReactComponent as ApproveIcon } from './approve.svg';
export { ReactComponent as ApprovedIcon } from './approved.svg';
export { ReactComponent as Backgroud_LOGIN } from './Backgroud_LOGIN.svg';
export { ReactComponent as BellIcon } from './bell.svg';
export { ReactComponent as Calendar } from './calendar.svg';
export { ReactComponent as CalendarBlue } from './CalendarBlue.svg';
export { ReactComponent as CheckCircleIcon } from './checkCircle.svg';
export { ReactComponent as CustomerIcon } from './customer-icon.svg';
export { ReactComponent as DateTimeIcon } from './date-time-icon.svg';
export { ReactComponent as DisabledRejectionIcon } from './disabled-rejection.svg';
export { ReactComponent as DownloadIcon } from './download.svg';
export { ReactComponent as DownloadTwoToneIcon } from './downloadTwoTone.svg';
export { ReactComponent as EditIcon } from './edit.svg';
export { ReactComponent as EditButtonIcon } from './edit_button.svg';
export { ReactComponent as EditDisableIcon } from './edit_disabled.svg';
export { ReactComponent as EditGrayIcon } from './EditGray.svg';
export { ReactComponent as Export } from './export.svg';
export { ReactComponent as ExcelIcon } from './exportExcel.svg';
export { ReactComponent as ExcelWhiteIcon } from './exportExcel_white.svg';
export { ReactComponent as EyeIcon } from './eye.svg';
export { ReactComponent as FilterIcon } from './filter.svg';
export { ReactComponent as FilterWhiteIcon } from './filter_white.svg';
export { ReactComponent as HistoryChange } from './history_change.svg';
export { ReactComponent as Import } from './import.svg';
export { ReactComponent as InformationIcon } from './info-icon.svg';
export { ReactComponent as Loader } from './loader.svg';
export { ReactComponent as IconLoading } from './Loading.svg';
export { ReactComponent as LOGO } from './logo.svg';
export { ReactComponent as LOGO_LOGIN } from './LOGO_Login.svg';
export { default as MarkerIcon } from './Marker.svg';
export {
  default as MarkerShopBludIcon,
  ReactComponent as MarkerShopNoteBludIcon,
} from './MarkerBlud.svg';
export {
  default as MarkerShopBrownIcon,
  ReactComponent as MarkerShopNoteBrownIcon,
} from './MarkerBrown.svg';
export {
  default as MarkerShopRedIcon,
  ReactComponent as MarkerShopRedNoteIcon,
} from './MarkerRed.svg';
export { ReactComponent as Minus } from './Minus.svg';
export { ReactComponent as MinusBordered } from './minus_bordered.svg';
export { ReactComponent as MoveIcon } from './move.svg';
export { ReactComponent as NotificationIcon } from './notification.svg';
export { ReactComponent as OrderIcon } from './order.svg';
export { ReactComponent as PendingApproveIcon } from './pending-approve.svg';
export { ReactComponent as PlanIcon } from './plan.svg';
export { ReactComponent as PlanBlueIcon } from './planBlue.svg';
export { ReactComponent as PlusIcon } from './plus.svg';
export { ReactComponent as PlusWhiteIcon } from './plusWhite.svg';
export { ReactComponent as PlusBordered } from './plus_bordered.svg';
export { ReactComponent as PrinterIcon } from './Printer.svg';
export { ReactComponent as PrinterWhiteIcon } from './PrinterWhite.svg';
export { ReactComponent as LOGO_PNJ } from './Rectangle.svg';
export { ReactComponent as RejectIcon } from './reject.svg';
export { ReactComponent as ReloadBlue } from './Reload-blue.svg';
export { ReactComponent as ReportIcon } from './report.svg';
export { ReactComponent as RewardIcon } from './reward.svg';
export { ReactComponent as SplitFill } from './split-fill.svg';
export { ReactComponent as Split } from './split.svg';
export { ReactComponent as StarIcon } from './star.svg';
export { ReactComponent as SystemIcon } from './system.svg';
export { ReactComponent as Team3Icon } from './team-3.svg';
export { ReactComponent as TeamIcon } from './team_icon.svg';
export { ReactComponent as TeamWorkIcon } from './teamwork.svg';
export { ReactComponent as UserIcon } from './user.svg';
export { ReactComponent as User3Icon } from './User3.svg';
export { ReactComponent as UserIconV2 } from './user_icon.svg';
export { ReactComponent as UserAddOuntLined } from './UserAddOutLined.svg';
export { ReactComponent as XIcon } from './x.svg';
export { ReactComponent as XGrayIcon } from './xgray.svg';
export { ReactComponent as XWhite } from './xwhite.svg';
export { ReactComponent as PlayIcon } from './Play.svg';
export { ReactComponent as Reload } from './reload.svg';
export { ReactComponent as FileIcon } from './file.svg';
export { ReactComponent as FileGrayIcon } from './file-gray.svg';
export { ReactComponent as HandoverIcon } from './Handover.svg';
export { ReactComponent as LockIcon } from './lock.svg';
export { ReactComponent as UnlockIcon } from './unlock.svg';
export { ReactComponent as StarNewIcon } from './cart-icon.svg';
export { ReactComponent as CartNewIcon } from './star-icon.svg';
